import api from '../utils/api';

export const fleetService = {
  // Dashboard
  getDashboard: () => api.get('/dashboard'),

  // Fleet owner wallet (ride payment settlement)
  getFleetWallet: () => api.get('/wallet'),
  getFleetWalletTransactions: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    return api.get(`/wallet/transactions?${queryParams.toString()}`);
  },
  getFleetEarningsSummary: () => api.get('/wallet/earnings-summary'),
  
  // Analytics
  getAnalytics: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    return api.get(`/analytics?${queryParams.toString()}`);
  },

  // Profile
  updateProfile: (profileData) => api.put('/profile', profileData),

  // Drivers
  getDrivers: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    return api.get(`/drivers?${queryParams.toString()}`);
  },
  getDriver: (driverId) => api.get(`/drivers/${driverId}`),
  createDriver: (driverData) => api.post('/drivers', driverData),
  updateDriver: (driverId, driverData) => api.put(`/drivers/${driverId}`, driverData),
  getDriverRides: (driverId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    return api.get(`/drivers/${driverId}/rides?${queryParams.toString()}`);
  },

  // Driver Wallet
  getDriverWallet: (driverId) => api.get(`/drivers/${driverId}/wallet`),
  getDriverWalletTransactions: (driverId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.type) queryParams.append('type', params.type);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    return api.get(`/drivers/${driverId}/wallet/transactions?${queryParams.toString()}`);
  },
  addFundsToWallet: (driverId, data) => api.post(`/drivers/${driverId}/wallet/add-funds`, data),
  withdrawFundsFromWallet: (driverId, data) => api.post(`/drivers/${driverId}/wallet/withdraw`, data),
  adjustWalletBalance: (driverId, data) => api.post(`/drivers/${driverId}/wallet/adjust`, data),

  // Vehicles
  getVehicles: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.vehicleType) queryParams.append('vehicleType', params.vehicleType);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    return api.get(`/vehicles?${queryParams.toString()}`);
  },
  getVehicle: (vehicleId) => api.get(`/vehicles/${vehicleId}`),
  createVehicle: (vehicleData) => api.post('/vehicles', vehicleData),
  updateVehicle: (vehicleId, vehicleData) => api.put(`/vehicles/${vehicleId}`, vehicleData),
  /** Fleet owner assigns one approved vehicle to one driver (driver may also self-select in app; same rules). */
  assignVehicleToDriver: (vehicleId, driverId) =>
    api.post(`/vehicles/${vehicleId}/assign`, { driverId }),
  unassignVehicle: (vehicleId) => api.post(`/vehicles/${vehicleId}/unassign`),

  // Rides
  getRides: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    if (params.driverId) queryParams.append('driverId', params.driverId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.search) queryParams.append('search', params.search);
    return api.get(`/rides?${queryParams.toString()}`);
  },
  getRide: (rideId) => api.get(`/rides/${rideId}`),
  getActiveRides: () => api.get('/rides/active'),

  // Vehicle Categories (Read-only, for dropdowns)
  getVehicleCategories: () => api.get('/vehicle-categories'),

  // Peak Hours (Read-only)
  getPeakHours: () => api.get('/peak-hours'),
  getRegions: () => api.get('/regions'),

  // Ride Verifications (Read-only)
  getRideVerifications: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.rideId) queryParams.append('rideId', params.rideId);
    if (params.driverId) queryParams.append('driverId', params.driverId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.isSuspicious !== undefined && params.isSuspicious !== '') queryParams.append('isSuspicious', params.isSuspicious);
    return api.get(`/ride-verifications?${queryParams.toString()}`);
  },
  getRideVerification: (id) => api.get(`/ride-verifications/${id}`),
};
